import React from 'react';
import { Compass } from '@phosphor-icons/react';

import { StatusShell } from '../../design-system/components/shells';
import { StatusAction } from '../../design-system/patterns/status';
import { routes } from '../../routes/routes';

/**
 * 404, the view. Pure: every input is a prop, every output a callback.
 *
 * A NEUTRAL DEAD END. The disc takes no tint at all, because a 404 is not an
 * error the user caused and not a failure of theirs to correct. Regular icon
 * weight for the same reason: nothing here is active or committed.
 *
 * THE STATUS CODE IS A KICKER, NOT A HEADLINE. The old page set it as three
 * giant digits, which made the number the loudest thing on a screen where the
 * number is the least useful thing on it. It sits above the headline now, at
 * kicker weight, the same relationship the card anatomy uses everywhere else.
 *
 * WHY THERE IS NO SEARCH BOX
 * --------------------------
 * The upstream template puts one here, and the reasoning is good: most dead
 * URLs on a marketplace are sold or delisted cards and the card still exists
 * under another seller. But `Marketplace.jsx` reads `set`, `catalog_group`,
 * `productType` and `tcg_category_id` from the query string and nothing else,
 * so a search from here would land on an unfiltered marketplace and silently
 * drop what the user typed. Shipping a control that cannot do what it says is
 * worse than not shipping it. It goes in when the marketplace reads a search
 * param, which is B3's job, not this one's.
 */

export function NotFoundView({ onGoBack }) {
  return (
    <StatusShell
      tone="neutral"
      icon={Compass}
      kicker="404"
      title="We cannot find that page"
      description="The link may be broken, or the listing may have sold and been taken down. The card is probably still here under another seller."
      actions={
        <>
          <StatusAction to={routes.MARKETPLACE}>Back to the marketplace</StatusAction>
          {onGoBack && (
            <StatusAction variant="ghost" onClick={onGoBack}>
              Go back
            </StatusAction>
          )}
        </>
      }
    />
  );
}

export default NotFoundView;
